import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { DefaultProduct } from "../pia-api/generated";
import { PiaProductsService } from "../pia-api/pia-products.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

// @param route

export const productDetailResolver: ResolveFn<
  Observable<DefaultProduct | null>
> = withLoading(
  (route: ActivatedRouteSnapshot): Observable<DefaultProduct | null> => {
    const piaProductsService = inject(PiaProductsService);
    const { productID, countryID, languageID, year } = pathParamsHelper(route);

    if (!productID || !countryID || !languageID || isNaN(year)) {
      return of(null);
    }

    const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

    return piaProductsService
      .getProductDetailsByProductID(
        {
          countryID,
          productID,
          languageID,
          year,
        },
        context,
      )
      .pipe(
        map((response) => response?.d ?? null),
        catchError(() => of(null)),
      );
  },
);
